import type { TenantedClient } from '@cotera/client/app/etc/api/typed-client';
import { navigateChatSeed } from './navigate';
import { resolveArtifactFolderId } from './resolve-artifact-folder';
import type {
  ChatSeedNavigateFn,
  ChatSeedNavigateResult,
  ChatSeedStrategy,
} from './types';

export async function openArtifactChatSeed(params: {
  client: TenantedClient['resource'];
  navigate: ChatSeedNavigateFn;
  orgSlug: string;
  strategy: ChatSeedStrategy;
  artifactId: string;
  folderId?: string;
  isNew?: boolean;
  replace?: boolean;
  chatId?: string;
  abortSignal?: AbortSignal;
}): Promise<ChatSeedNavigateResult | null> {
  const folderId = await resolveArtifactFolderId(
    params.client,
    params.strategy.artifactResourceType,
    params.artifactId,
    params.folderId
  );

  if (params.abortSignal?.aborted === true) {
    return null;
  }

  return navigateChatSeed(params.strategy, params.navigate, params.orgSlug, {
    artifactId: params.artifactId,
    ...(params.isNew === true && { isNew: true }),
    ...(folderId !== undefined && { folderId }),
    ...(params.chatId !== undefined && { chatId: params.chatId }),
    ...(params.replace === true && { replace: true }),
  });
}
